<template>
  <Mobile v-if="isMobile"></Mobile>
  <PC v-else></PC>
</template>

<script>
import Mobile from '@/components/Mobile.vue';
import PC from '@/components/PC.vue';
import {isMobile} from '@/tools/utils'

export default {
  name: 'Base',
  components: {
    Mobile,
    PC
  },
  data() {
    return {
      isMobile: isMobile(),
      deviceType: 0
    }
  },
  methods: {
    checkOrientation() {
      let ww = window.innerWidth
      let wh = window.innerHeight
      if (ww < wh) {
        this.deviceType = 1
      } else {
        this.deviceType = 2
      }
    }
  },
  mounted() {
    this.checkOrientation()
    // let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    // window.addEventListener(resizeEvt, this.checkOrientation, false);
  },
}
</script>

<style lang="stylus">
  .mobile,.pcwin{
    position relative
  }
  .mobile .age{
    position: absolute;
    left: 10px;
    bottom: 2.5rem;
    z-index 100
    transform: scale(0.5);
    transform-origin: center top;
  }
  .pcwin .age{
    position: absolute;
    left: 10px;
    bottom: 295px;
    transform: scale(0.8);
  }
</style>